import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3l2 3l2 15h-8l2 -15l2 -3","key":"svg-0"}],["path",{"d":"M8 9l8 0","key":"svg-1"}],["path",{"d":"M3 11l2 -2l-2 -2","key":"svg-2"}],["path",{"d":"M21 11l-2 -2l2 -2","key":"svg-3"}]]

const IconBuildingLighthouse = createReactComponent('outline', 'building-lighthouse', 'BuildingLighthouse', __iconNode);

export default IconBuildingLighthouse;